import { memo } from 'react';
import { calculatePercentage } from 'src/utils/mathUtils';

import styles from './styles.module.scss';
export interface IBufferProps {
  bufferStart: number;
  bufferEnd: number;
  duration: string;
  currentTime: string;
}

const BufferedGraph = ({ bufferStart, bufferEnd, duration, currentTime }: IBufferProps) => {

  const currentTimeParser = parseInt(currentTime.slice(0, -1));
  const durationParser = parseInt(duration.slice(0, -1));

  return (
    <div role='status' className={styles.bufferGraph}>
      <div
        data-testid='buffer-area' 
        className={styles.bufferArea} 
        style={{
          width: `${calculatePercentage(bufferEnd - bufferStart, durationParser)}%` || 0,
          left: `${calculatePercentage(bufferStart, durationParser)}%` || 0, 
        }}
      />
      <div 
        className={styles.bufferIndicator}
        data-testid='buffer-indicator'
        style={{
          left: `${calculatePercentage(currentTimeParser - 2, durationParser)}%` || 0,
        }}
      />
    </div>
  );
};

export default memo(BufferedGraph);
